import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { LinkButton } from 'core/components';
import { get } from 'lodash';

@inject('$app', '$explorer')
@observer
export default class ViewInExplorerButton extends Component {
  static defaultProps = {
    dataview: {},
    small: true,
    minimal: true,
    text: 'View in Data Explorer',
    icon: 'series-search',
    openInNewWindow: false
  };

  state = {
    dataLink: null
  };

  async getDataLink() {
    const { $explorer, query, dataview } = this.props;
    const { hash } = dataview;
    const selectedQuery = query || get(dataview, 'queryBuckets.selectedQuery');

    if (hash) {
      return `/v4/core/explorer/${hash}`;
    }

    return $explorer.getQueryPath(selectedQuery);
  }

  componentDidMount() {
    this.getDataLink().then((dataLink) => {
      this.setState({ dataLink });
    });
  }

  render() {
    const { $app, small, minimal, showIcon, text, icon, openInNewWindow, ...buttonProps } = this.props;
    const { dataLink } = this.state;
    if ($app.isExport || $app.isSubtenant) {
      return null;
    }

    return (
      <LinkButton
        small={small}
        minimal={minimal}
        icon={icon}
        text={text || ''}
        to={dataLink}
        disabled={!dataLink}
        blank={openInNewWindow}
        {...buttonProps}
      />
    );
  }
}
